module.exports = "//static.hsappstatic.net/pricing-pages-lib/static-1.25325/images/keyFeatures/Buyer_Intent.png"